<template>
  <div class="w-100">
    <div
      v-for="(intent, intentIndex) in data.intent"
      :key="intentIndex"
      class="w-100 d-flex"
    >
      <div
        v-bind:class="[
          'w-100',
          {
            'd-none': languageActiveId !== intent.language,
          },
          { 'd-flex': languageActiveId === intent.language },
        ]"
      >
        <div
          class="d-flex w-100"
          @click="$emit('getNextFlowLists', level, data)"
        >
          <div class="my-auto">
            <font-awesome-icon
              icon="chevron-down"
              class="chevron-down"
              v-if="flowActiveIds.includes(data.mainIntentId)"
            />
            <font-awesome-icon
              icon="chevron-right"
              class="chevron-right"
              v-else
            />
          </div>
          <div class="ml-3 my-auto d-flex w-100">
            <div class="mb-0 my-auto w-100">
              <div class="text-flow-name">{{ intent.name }}</div>
              <div class="text-gray f-size-12" v-if="intent.suggest">
                {{ intent.suggest }}
              </div>
            </div>
            <span class="ml-auto mr-2 my-auto" v-if="data.percent > 1">
              <IntentAceessChart ref="skills_chart" :percent="data.percent">
              </IntentAceessChart>
            </span>
          </div>
        </div>

        <div class="ml-auto my-auto d-flex">
          <div>
            <toggle-button
              class="mt-1 mr-2"
              v-model="data.active"
              :color="{
                checked: '#27BDA7',
                unchecked: '#F1F1F1',
                disabled: '#CCCCCC',
              }"
              :labels="{ checked: 'On', unchecked: 'Off' }"
              @change="handleChangeStatus"
            />
          </div>
          <div>
            <b-dropdown
              size="lg"
              variant="link"
              toggle-class="text-decoration-none text-gray"
              no-caret
              class="dropdown-intent"
            >
              <template #button-content>
                <font-awesome-icon icon="ellipsis-v" class="mt-2 pointer" />
              </template>
              <b-dropdown-item-button @click="$emit('updateIntent', data)">
                <div>Edit This Intent</div>
              </b-dropdown-item-button>
              <b-dropdown-item-button
                @click="openModalDelete(data.mainIntentId, intent)"
                >Remove</b-dropdown-item-button
              >
              <!-- <b-dropdown-form class="d-flex w-100 p-0">
                <div class="w-100">Enable ML</div>
                <div class="ml-3">
                  <toggle-button
                    v-model="data.enableML"
                    :labels="false"
                    :color="{
                      checked: '#27BDA7',
                    }"
                    @change="handleChangeEnableML"
                  />
                </div>
              </b-dropdown-form> -->
            </b-dropdown>
          </div>
        </div>
      </div>
    </div>

    <ModalAlertConfirm
      msg="ยืนยันการลบ ?"
      :text="modalMessage"
      btnConfirm="ลบ"
      colorBtnConfirm="danger"
      btnCancel="ยกเลิก"
      ref="ModalAlertConfirm"
      @confirm="btnDelete"
    />
    <ModalLoading ref="modalLoading" :hasClose="false" />
    <ModalAlert
      ref="modalAlert"
      :text="modalMessage"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
    />
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
  </div>
</template>

<script>
import ModalLoading from "@/components/modal/alert/ModalLoading";
import ModalAlert from "@/components/modal/alert/ModalAlert";
import ModalAlertError from "@/components/modal/alert/ModalAlertError";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";
import IntentAceessChart from "./chart/IntentAceessChart.vue";

export default {
  props: {
    data: {
      required: true,
      type: Object,
    },
    flowActiveIds: {
      required: true,
      type: Array,
    },
    languageActiveId: {
      required: true,
      type: Number,
    },
    filter: {
      required: false,
      type: Object,
    },
    isInFilter: {
      required: false,
      type: Boolean,
    },
    level: {
      required: true,
      type: Number,
    },
  },
  components: {
    ModalAlert,
    ModalLoading,
    ModalAlertError,
    ModalAlertConfirm,
    IntentAceessChart,
  },
  data() {
    return {
      responseId: null,
      modalMessage: "",
      requestDeleteFlow: {
        flowId: null,
      },
      option: {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          animateRotate: false,
        },
      },
      chartData: {
        labels: ["skill1"],
        datasets: [
          {
            backgroundColor: ["black", "white"],
            data: [1],
          },
        ],
      },
    };
  },
  computed: {
    currentDataSet() {
      return this.chartData.datasets[0].data;
    },
  },

  methods: {
    hadleModalAlertClose() {
      this.$emit("onReloadFlowList");
    },
    openModalDelete(id, intent) {
      this.requestDeleteFlow.flowId = id;
      this.modalMessage = "คุณต้องการลบ " + intent.name + " ใช่หรือไม่?";
      this.$refs.ModalAlertConfirm.show();
    },
    btnDelete: async function () {
      this.$refs.ModalAlertConfirm.hide();
      this.$refs.modalLoading.show();
      await this.axios
        .delete(
          `${this.$baseUrl}/flowBuilder/delete/${this.requestDeleteFlow.flowId}`
        )
        .then((data) => {
          this.$refs.modalLoading.hide();
          if (data.result == 1) {
            this.modalMessage = data.message;
            this.$refs.modalAlert.show();
          } else {
            this.modalMessage = data.detail[0];
            this.$refs.modalAlertError.show();
          }
        });
    },

    handleCloseModal() {
      this.$emit("onReloadFlowList");
    },
    handleChangeEnableML() {
      const body = {
        Id: this.data.mainIntentId,
        Active: this.data.active,
      };
      this.axios
        .post(`${this.$baseUrl}/flowBuilder/enableML`, body)
        .then((data) => {
          if (data.result == 1) {
            //this.$emit("onReloadFlowList");
          } else {
            this.modalMessage = data.detail[0];
            this.$refs.modalAlertError.show();
            this.$emit("onReloadFlowList");
          }
        });
    },
    handleChangeStatus() {
      const body = {
        Id: this.data.mainIntentId,
        Active: this.data.active,
      };
      this.axios
        .post(`${this.$baseUrl}/flowBuilder/status`, body)
        .then((data) => {
          if (data.result == 1) {
            // this.$emit("onReloadFlowList");
          } else {
            this.modalMessage = data.detail[0];
            this.$refs.modalAlertError.show();
            this.$emit("onReloadFlowList");
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .dropdown > button {
  padding: 0 !important;
  position: relative;
  bottom: 3px;
  color: black;
}
::v-deep .vue-js-switch .v-switch-label[data-v-25adc6c0] {
  position: absolute;
  top: 0;
  font-weight: 600;
  color: transparent;
  z-index: 1;
  margin-bottom: 0;
}
.text-flow-name {
  font-size: 1rem;
}
.f-size-12 {
  font-size: 12px;
}
</style>
